import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { CustomFile } from '../../Types/file';
import { getFolderFiles, getUserFiles } from '../actions/fileActions';
import { RootState } from '../store';

interface FilesState {
  userFiles: CustomFile[];
  totalUserFiles: number;
  folderFiles: CustomFile[];
  totalFolderFiles: number;
  searchQuery: string;
}

const initialState: FilesState = {
  userFiles: [],
  totalUserFiles: 0,
  folderFiles: [],
  totalFolderFiles: 0,
  searchQuery: '',
};

const filesSlice = createSlice({
  name: 'files',
  initialState,
  reducers: {
    setUserFiles: (state, action: PayloadAction<CustomFile[]>) => {
      state.userFiles = action.payload;
    },
    setFolderFiles: (state, action: PayloadAction<CustomFile[]>) => {
      state.folderFiles = action.payload;
    },
    setSearchQuery: (state, action: PayloadAction<string>) => {
      state.searchQuery = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      getUserFiles.fulfilled,
      (state, action: PayloadAction<{ data: CustomFile[]; total: number }>) => {
        state.userFiles = action.payload.data;
        state.totalUserFiles = action.payload.total;
      }
    );
    builder.addCase(
      getFolderFiles.fulfilled,
      (state, action: PayloadAction<{ data: CustomFile[]; total: number }>) => {
        state.folderFiles = action.payload.data;
        state.totalFolderFiles = action.payload.total;
      }
    );
  },
});

export const { setUserFiles, setFolderFiles, setSearchQuery } = filesSlice.actions;

export const selectFiles = (state: RootState) => state.files;

export default filesSlice.reducer;
